import VaultShowDocument from '../../pages/veeva_vault/ShowDocument';
import VaultTasks from '../../pages/veeva_vault/tasks/Tasks';
import VaultShowTask from '../../pages/veeva_vault/tasks/ShowTask';
import VaultWizard from '../../pages/veeva_vault/wizard/Wizard';
import VaultAdminHome from '../../pages/veeva_vault/AdminHome';

export default [
    {
        path: '/v2/admin/veeva/vault/admin',
        name: 'vv.admin',
        component: VaultAdminHome,
        meta: {
            permission: 'can_edit_presentations',
        },
    },
    {
        path: '/v2/admin/veeva/vault/connections/:connectionID/document/:documentID(\\d+)',
        name: 'vv.document.show',
        component: VaultShowDocument,
        meta: {
            permission: 'can_edit_presentations',
        },
    },
    {
        path: '/v2/admin/veeva/vault/tasks',
        name: 'vv.tasks',
        component: VaultTasks,
        meta: {
            permission: 'can_edit_presentations',
        },
    },
    {
        path: '/v2/admin/veeva/vault/tasks/:taskID(\\d+)',
        name: 'vv.task.show',
        component: VaultShowTask,
        meta: {
            permission: 'can_edit_presentations',
        },
    },
    {
        path: '/v2/admin/veeva/vault/import',
        name: 'vv.import.wizard',
        component: VaultWizard,
        meta: {
            permission: 'can_edit_presentations',
        },
    }
]
